import { render, staticRenderFns } from "./RecepcionActividadForm.vue?vue&type=template&id=a552400e&"
import script from "./RecepcionActividadForm.vue?vue&type=script&lang=ts&"
export * from "./RecepcionActividadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports